import {
  ACT_INSTANCES_FETCH_PRODUCTS_INIT_ACTION,
  ACT_INSTANCES_FETCH_PRODUCTS_SUCCESS_ACTION,
  ACT_INSTANCES_GET_PRODUCT_INIT_ACTION,
  ACT_INSTANCES_GET_PRODUCT_SUCCESS_ACTION,
  ACT_INSTANCES_ADD_PRODUCT_INIT_ACTION,
  ACT_INSTANCES_ADD_PRODUCT_SUCCESS_ACTION,
  ACT_INSTANCES_DELETE_PRODUCT_INIT_ACTION,
  ACT_INSTANCES_DELETE_PRODUCT_SUCCESS_ACTION,
  ACT_INSTANCES_UPDATE_PRODUCTS_FILTERS,
  ACT_INSTANCES_SET_SELECTED_PRODUCT,
} from '../../constants/actions';

const defaultState = {
  products: [],
  singleProduct: undefined,
  didLoadProducts: false,
  isLoadingProducts: false,
  isLoadingSingleProduct: false,
  isAddingProduct: false,
  isDeletingProduct: false,
  isProductDeleted: false,
  selectedProduct: undefined,
  filters: {
    dynasties: [],
    cities: [],
    tags: [],
    types: [],
  },
};

const productsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ACT_INSTANCES_FETCH_PRODUCTS_INIT_ACTION:
      return {
        ...state,
        products: [],
        isLoadingProducts: true,
        didLoadProducts: false,
      };
    case ACT_INSTANCES_FETCH_PRODUCTS_SUCCESS_ACTION:
      return {
        ...state,
        products: action.payload,
        isLoadingProducts: false,
        didLoadProducts: true,
      };
    case ACT_INSTANCES_ADD_PRODUCT_INIT_ACTION:
      return {
        ...state,
        isAddingProduct: true,
      };
    case ACT_INSTANCES_ADD_PRODUCT_SUCCESS_ACTION: {
      const newProductsList = state.products.push(action.payload);
      return {
        ...state,
        isAddingProduct: false,
        products: newProductsList,
      };
    }
    case ACT_INSTANCES_GET_PRODUCT_INIT_ACTION:
      return {
        ...state,
        singleProduct: undefined,
        isLoadingProducts: true,
      };
    case ACT_INSTANCES_GET_PRODUCT_SUCCESS_ACTION:
      return {
        ...state,
        singleProduct: action.payload,
        isLoadingSingleProduct: false,
      };
    case ACT_INSTANCES_DELETE_PRODUCT_INIT_ACTION:
      return {
        ...state,
        isDeletingProduct: true,
        isProductDeleted: false,
      };
    case ACT_INSTANCES_DELETE_PRODUCT_SUCCESS_ACTION:
      return {
        ...state,
        isDeletingProduct: false,
        isProductDeleted: true,
      };
    case ACT_INSTANCES_UPDATE_PRODUCTS_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case ACT_INSTANCES_SET_SELECTED_PRODUCT:
      return {
        ...state,
        selectedProduct: action.payload,
        singleProduct: action.payload,
      };
    default:
      return state;
  }
};

export default productsReducer;
